/**
 * Landing Page Model
 * Defines the data structures and types for the landing feature
 */

// App benefit item type
export interface AppBenefit {
  id: string;
  text: string;
  icon: string;
}

// App store link configuration
export interface AppStoreConfig {
  playStoreUrl: string;
  appStoreUrl: string;
}

// Landing page configuration
export interface LandingConfig {
  appName: string;
  logo?: string;
}

// User actions that can be performed on landing page
export type LandingAction = "download_app" | "continue_web" | "toggle_theme";

// Default configuration
export const defaultLandingConfig: LandingConfig = {
  appName: "Neobhi",
};

// Default app store configuration
export const defaultAppStoreConfig: AppStoreConfig = {
  playStoreUrl:
    "https://play.google.com/store/apps/details?id=com.neobhi.neocc.mobile&pcampaignid=web_share",
  appStoreUrl: "https://apps.apple.com/in/app/callee/id6745335143",
};

// Default benefits list
export const defaultBenefits: AppBenefit[] = [
  { id: "1", text: "Faster performance & smoother navigation", icon: "✓" },
  { id: "2", text: "Push notifications for instant updates", icon: "✓" },
  { id: "3", text: "Better connectivity & reliability", icon: "✓" },
];
